import { render, staticRenderFns } from "./scope81.vue?vue&type=template&id=41b33f54&scoped=true"
import script from "./scope81.vue?vue&type=script&lang=js"
export * from "./scope81.vue?vue&type=script&lang=js"
import style0 from "./scope81.vue?vue&type=style&index=0&id=41b33f54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b33f54",
  null
  
)

export default component.exports